import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=499dfc4c&scoped=true"
import script from "./fuwu.vue?vue&type=script&lang=js"
export * from "./fuwu.vue?vue&type=script&lang=js"
import style0 from "./fuwu.vue?vue&type=style&index=0&id=499dfc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499dfc4c",
  null
  
)

export default component.exports